import { ArticleLogisticalUnit, PackageDimensions } from '../types';

export const articleLogisticDimension: {
  [key in ArticleLogisticalUnit]: string;
} = {
  [ArticleLogisticalUnit.PALLET_EUR1]: 'P 80 × 120',
  [ArticleLogisticalUnit.PALLET_EUR2]: 'P 120 × 100',
  [ArticleLogisticalUnit.PALLET_EUR6]: 'P 80 × 60',
};
export const articleLogisticDimensions: {
  [key in ArticleLogisticalUnit]: PackageDimensions;
} = {
  [ArticleLogisticalUnit.PALLET_EUR1]: {
    length: 1200,
    width: 800,
    weight: 20,
    height: 150,
  },
  [ArticleLogisticalUnit.PALLET_EUR2]: {
    length: 1200,
    width: 1000,
    weight: 20,
    height: 150,
  },
  [ArticleLogisticalUnit.PALLET_EUR6]: {
    length: 800,
    width: 600,
    weight: 20,
    height: 150,
  },
};

export function formatArticleLogisticalUnit(
  articleLogisticalUnit: ArticleLogisticalUnit,
): string {
  const result = articleLogisticDimension[articleLogisticalUnit];

  if (!result) throw new Error('Unknown article logistical unit');

  return result;
}
